<panel width="400">
	<h1>{{ (user?.id ? user!.name : 'user.create-headline') | translate }}</h1>
	@if (!user) { <skeleton /> }
	@else {
		@if (user.id == undefined) {
			<section>
				<custom-select [selectList]="adUserList"
							   [placeholder]="'user.ad-user-placeholder' | translate"
							   (valueChange)="selectAdUser($event)" />
				<custom-input [inputType]="inputType.Checkbox" [label]="'user.ad-user-include-all' | translate" [(value)]="includeAllAdUsers" (valueChange)="filterAdUsers()" />
			</section>
		}
		@if (user.adIdentifier != undefined) {
			<section>
				<text-group>
					<span>{{ 'user.username' | translate }}</span>
					<span>{{ user.username }}</span>
					<span>{{ 'general.name' | translate }}</span>
					<span>{{ user.name }}</span>
					<span>{{ 'general.email' | translate }}</span>
					<span>{{ user.email }}</span>
				</text-group>
				<custom-input [inputType]="inputType.Switch" [label]="'user.admin' | translate" [(value)]="user.admin" />
			</section>
			<h2>{{ 'user.teams' | translate }}</h2>
			<list-view scrollable [selectable]="false">
				<header defaultSort="descending"></header>
				<header>{{ 'general.name' | translate }}</header>
				<header>{{ 'user.team.sale' | translate }}</header>
				<row *listData="let team from teams" (action)="selectTeam(team)">
					<column [sortValue]="team.wasSelected"><input type="checkbox" [(checked)]="team.selected" /></column>
					<column>{{ team.name }}</column>
					<column>{{ 'general.' + team.sale | translate }}</column>
				</row>
			</list-view>
			@if (checkedSalesTeams.length > 0) {
				<section>
					<custom-select [label]="'user.default-sales-team' | translate" [selectList]="checkedSalesTeams" [(value)]="user.defaultSalesTeamId" />
				</section>
			}
		}
		<section>
			<button confirm #saveButton (click)="save()">{{ 'general.save' | translate }}</button>
		</section>
	}
</panel>
